import {AppraiserCreate, AppraiserEdit, AppraiserList} from '@/admin/resources/appraisers/Appraisers';

export default {
  list: AppraiserList,
  edit: AppraiserEdit,
  create: AppraiserCreate,
};
